export default __webpack_public_path__ + "static/media/Bracers of Bristling Ire.bebe1cbd.jpg";